export const seoPages = [
  {
    slug: "/dj-matrimoni-lugano",
    title: "DJ Matrimoni Lugano | Musica, Luci ed Effetti – DJ Magix",
    description:
      "DJ per matrimoni a Lugano e Paradiso: musica su misura, luci, fontane fredde e 25 anni di esperienza. Sopralluogo e preventivo gratuiti.",
    eyebrow: "Matrimoni — Lugano",
    h1: "DJ per Matrimoni a Lugano",
    intro:
      "Il tuo matrimonio a Lugano merita una colonna sonora indimenticabile: dalla cerimonia all'ultimo ballo, ogni momento con la musica giusta.",
    image: "/assets/matrimonio2.webp",
    paragraphs: [
      {
        h2: "La colonna sonora del tuo giorno più bello",
        text: "Con base a Lugano-Paradiso, DJ Magix segue matrimoni in tutta la zona: aperitivo soft, cena con sottofondo elegante e poi festa scatenata con sound anni 80/90, disco dance, afro house e techno. Ogni scaletta è costruita insieme agli sposi, ascoltando i vostri gusti e quelli dei vostri ospiti.",
      },
      {
        h2: "Attrezzatura professionale ed effetti speciali",
        text: "Impianto audio e luci proprio, adatto a sale fino a 1000 persone, microfoni wireless per discorsi e cerimonia, e su richiesta fontane fredde per il taglio della torta o il primo ballo. Preventivo gratuito e senza impegno, con sopralluogo della location se necessario.",
      },
      {
        h2: "Come lavoro: dal primo incontro all'ultimo ballo",
        text: "Tutto inizia da una chiacchierata, di persona o in videochiamata: mi raccontate la location, i tempi della giornata e i brani che non possono mancare. Settimane prima delle nozze prepariamo insieme la scaletta dei momenti chiave — ingresso, primo ballo, taglio della torta — così quel giorno pensate solo a vivervi la festa. Il giorno dell'evento arrivo con largo anticipo per montaggio e soundcheck, senza mai essere d'intralcio ai preparativi.",
      },
      {
        h2: "Matrimoni sul Lago di Lugano e in tutto il luganese",
        text: "Lavoro regolarmente tra Lugano, Paradiso, Agno, Morcote, Melide e tutta la riviera: ville con giardino sul lago, terrazze panoramiche, ristoranti e sale ricevimento del luganese. Conosco le esigenze pratiche di queste location — orari, volumi, spazi per l'impianto — e coordino tutto direttamente con chi gestisce la sala, così non dovete pensare a nulla.",
      },
      {
        h2: "Prezzi chiari e sopralluogo gratuito",
        text: "I matrimoni partono da CHF 500 con impianto audio e luci incluso; il prezzo finale dipende da durata, effetti speciali e logistica. Se la location è nel luganese il sopralluogo è gratuito: vedo gli spazi, parlo con il responsabile e vi lascio un preventivo scritto, dettagliato e senza impegno. Niente costi nascosti, mai.",
      },
    ],
    relatedLinks: [
      { to: "/dj-matrimoni-ticino", label: "DJ per matrimoni in tutto il Ticino" },
      { to: "/dj-matrimoni-lago-di-como", label: "Matrimoni sul Lago di Como" },
      { to: "/blog/canzoni-primo-ballo-matrimonio", label: "Le canzoni per il primo ballo" },
      { to: "/blog/scegliere-dj-matrimonio-ticino", label: "Come scegliere il DJ per il matrimonio" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
      { to: "/servizi", label: "Tutti i servizi per eventi" },
    ],
  },
  {
    slug: "/dj-matrimoni-ticino",
    title: "DJ Matrimoni Ticino | Da Locarno a Mendrisio – DJ Magix",
    description:
      "DJ per matrimoni in tutto il Ticino: scaletta su misura, impianto professionale, microfoni wireless. Preventivo gratuito e senza impegno.",
    eyebrow: "Matrimoni — Ticino",
    h1: "DJ per Matrimoni in Ticino",
    intro:
      "Da Bellinzona a Locarno, da Lugano a Chiasso: DJ Magix porta la festa perfetta nel tuo matrimonio in ogni angolo del Ticino.",
    image: "/assets/gallery5.webp",
    paragraphs: [
      {
        h2: "Un DJ che conosce le location del Ticino",
        text: "Castelli, grotti, ville sul lago e sale ricevimento: in 25 anni di eventi in Ticino ho suonato nelle location più belle del cantone. So come adattare audio e luci a ogni spazio, dal giardino all'aperto alla sala storica.",
      },
      {
        h2: "Musica per tutte le generazioni",
        text: "Il segreto di un matrimonio riuscito è far ballare tutti: revival anni 80/90 per i grandi, hit del momento per i giovani, disco dance e afro house per la pista piena fino a notte fonda. L'evento è condotto in italiano; per matrimoni con ospiti internazionali prepariamo insieme scaletta e annunci in anticipo.",
      },
      {
        h2: "Da Locarno a Mendrisio: copertura di tutto il cantone",
        text: "Soprannavigando il Ticino da 25 anni conosco le realtà di ogni zona: le terrazze del Locarnese e della Vallemaggia, le sale del Bellinzonese, i ristoranti del Luganese e le location del Mendrisiotto fino a Chiasso. La trasferta dentro il cantone è sempre inclusa nel preventivo: nessun costo a sorpresa per chilometri o montaggio.",
      },
      {
        h2: "Cosa include il servizio matrimonio",
        text: "Musica per aperitivo, cena e festa; impianto audio e luci professionale fino a 1000 ospiti; microfoni wireless per cerimonia e discorsi; incontro conoscitivo e scaletta personalizzata. Su richiesta: fontane fredde per il primo ballo o il taglio torta, effetti luce scenografici e karaoke per il dopo cena. I matrimoni partono da CHF 500, con preventivo gratuito e senza impegno.",
      },
      {
        h2: "Le domande che mi fanno gli sposi ticinesi",
        text: "Quanto prima prenotare? I weekend tra maggio e settembre vanno via in fretta: appena avete la data, sentiamoci. Pioggia? Per gli eventi all'aperto concordiamo sempre un piano B con la location. Musica durante la cerimonia civile? Sì, con impianto dedicato e microfono per il celebrante. Ogni dettaglio lo decidiamo insieme, con calma, prima del grande giorno.",
      },
    ],
    relatedLinks: [
      { to: "/dj-matrimoni-lugano", label: "DJ per matrimoni a Lugano" },
      { to: "/blog/scegliere-dj-matrimonio-ticino", label: "Come scegliere il DJ per il matrimonio" },
      { to: "/blog/canzoni-primo-ballo-matrimonio", label: "Le canzoni per il primo ballo" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
      { to: "/dj-compleanni-feste-private", label: "DJ per compleanni e feste private" },
    ],
  },
  {
    slug: "/dj-eventi-aziendali-svizzera",
    title: "DJ Eventi Aziendali Svizzera | Gala e Cene – DJ Magix",
    description:
      "DJ e regia audio per eventi aziendali, gala, lanci di prodotto e cene in Svizzera. Microfoni wireless, luci e impianto inclusi. Preventivo gratuito.",
    eyebrow: "Corporate — Svizzera",
    h1: "DJ per Eventi Aziendali in Svizzera",
    intro:
      "Cene aziendali, lanci di prodotto, convention e feste di Natale: musica e regia audio impeccabili per l'immagine della tua azienda.",
    image: "/assets/gallery1.webp",
    section: "services",
    paragraphs: [
      {
        h2: "Professionalità al servizio del tuo brand",
        text: "Un evento aziendale richiede tempi precisi e discrezione: microfonia wireless per speech e premiazioni, sottofondo musicale calibrato durante la cena e DJ set finale per chiudere in festa. Coordinate con il vostro event manager o con la location, senza pensieri per voi.",
      },
      {
        h2: "Copertura in tutta la Svizzera",
        text: "Base a Lugano-Paradiso e disponibilità in tutta la Svizzera: Ticino, Zurigo, Ginevra, Berna, Basilea e Nord Italia. Attrezzatura audio e luci propria fino a 1000 persone, così non dovete noleggiare nulla separatamente.",
      },
    ],
    relatedLinks: [
      { to: "/servizi", label: "Tutti i servizi DJ" },
      { to: "/dj-festival-party-stagionali", label: "DJ per feste di paese e festival" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
      { to: "/preventivo", label: "Richiedi un preventivo gratuito" },
    ],
  },
  {
    slug: "/dj-compleanni-feste-private",
    title: "DJ Compleanni e Feste Private in Ticino – DJ Magix",
    description:
      "DJ per compleanni, 18 anni e feste private in Ticino: playlist su misura, karaoke professionale e luci. Preventivo gratuito.",
    eyebrow: "Party Privati",
    h1: "DJ per Compleanni e Feste Private",
    intro:
      "Diciottesimi, trentesimi, cinquantesimi e ogni traguardo in mezzo: la tua festa privata con la musica che ami, dal primo all'ultimo brano.",
    image: "/assets/compleanno-locale-ticino.webp",
    paragraphs: [
      {
        h2: "Una playlist cucita su di te",
        text: "Prima della festa parliamo dei tuoi gusti: i brani della tua giovinezza, le hit che ami oggi, i tormentoni che faranno cantare tutti. Sound anni 80/90, disco dance, afro house, techno e su richiesta karaoke professionale con migliaia di basi.",
      },
      {
        h2: "Casa, giardino o sala affittata: porto tutto io",
        text: "Impianto audio e luci professionale adatto a ogni spazio, dal salotto di casa al capannone della festa. Montaggio e smontaggio inclusi, pensi solo a divertirti. Feste private da CHF 200-300, preventivo gratuito e senza impegno.",
      },
    ],
    relatedLinks: [
      { to: "/dj-festival-party-stagionali", label: "DJ per feste di paese e sagre" },
      { to: "/servizi", label: "Tutti i servizi DJ" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
      { to: "/preventivo", label: "Richiedi un preventivo gratuito" },
    ],
  },
  {
    slug: "/dj-festival-party-stagionali",
    title: "DJ Feste di Paese e Festival in Ticino – DJ Magix",
    description:
      "DJ per feste di paese, sagre e festival: amplificazione potente per grandi piazze e pubblico di tutte le età. Preventivo per i comitati.",
    eyebrow: "Festival & Sagre",
    h1: "DJ per Feste di Paese, Sagre e Party Stagionali",
    intro:
      "Piazze piene, tendoni, feste dell'uva e serate d'estate: l'energia giusta per far ballare tutto il paese, dai più piccoli ai nonni.",
    image: "/assets/gallery2.webp",
    paragraphs: [
      {
        h2: "Esperienza con le grandi piazze",
        text: "Le feste di paese sono la mia seconda casa: gestione della folla, scalette che accontentano tutte le età e un impianto potente fino a 1000 persone. Collaboro con comitati e pro loco del Ticino da anni, con preventivi chiari e massima affidabilità.",
      },
      {
        h2: "Dalla sagra al festival",
        text: "Festa patronale, carnevale, capodanno in piazza o party sulla spiaggia: porto musica, luci ed effetti speciali anche all'aperto. Possibilità di karaoke, giochi musicali e animazione tra un set e l'altro.",
      },
    ],
    relatedLinks: [
      { to: "/blog/dj-festa-di-paese-ticino", label: "Guida: il DJ per la festa di paese" },
      { to: "/dj-compleanni-feste-private", label: "DJ per compleanni e feste private" },
      { to: "/servizi", label: "Tutti i servizi DJ" },
      { to: "/preventivo", label: "Preventivo per comitati" },
    ],
  },
  {
    slug: "/dj-zurigo",
    title: "DJ per Matrimoni ed Eventi a Zurigo – DJ Magix",
    description:
      "DJ dal Ticino per matrimoni ed eventi a Zurigo: impianto audio e luci proprio, trasferta organizzata, preventivo gratuito.",
    eyebrow: "Zurigo",
    h1: "DJ a Zurigo per Eventi e Matrimoni",
    intro:
      "Dal Ticino a Zurigo con tutta l'attrezzatura: DJ set professionali per matrimoni, aziende e feste private nella città sulla Limmat.",
    image: "/assets/gallery1.webp",
    paragraphs: [
      {
        h2: "Trasferte in tutta la Svizzera",
        text: "Opero regolarmente entro 200 km dal Ticino: Zurigo è una delle mie destinazioni abituali per matrimoni ed eventi aziendali. Arrivo con impianto audio e luci proprio, quindi la location non deve fornire nulla.",
      },
      {
        h2: "Un DJ italiano per eventi a Zurigo",
        text: "Conduco ogni evento in italiano — perfetto per la comunità italiana di Zurigo e per matrimoni con ospiti da tutta la Svizzera: scaletta, annunci e momenti chiave li prepariamo insieme in anticipo. Repertorio internazionale con revival anni 80/90, disco dance, afro house e techno.",
      },
      {
        h2: "Come funziona la trasferta a Zurigo",
        text: "Nessuna complicazione per voi: il viaggio, il montaggio e lo smontaggio dell'impianto sono compresi nel preventivo. Arrivo in location con diverse ore di anticipo, faccio il soundcheck e coordino i tempi con il catering o il wedding planner. Per gli eventi serali organizzo il pernottamento in autonomia: voi vedete solo il risultato finale.",
      },
      {
        h2: "Per matrimoni, aziende e feste private",
        text: "A Zurigo porto lo stesso servizio completo che offro in Ticino: matrimoni dalla cerimonia all'ultimo ballo, cene aziendali e gala con regia audio per speech e premiazioni, compleanni e feste private con playlist su misura. Effetti speciali come le fontane fredde disponibili su richiesta, dove la location li consente.",
      },
      {
        h2: "Preventivo chiaro, anche con la trasferta",
        text: "Il preventivo per Zurigo è scritto, gratuito e senza impegno: include musica, impianto, montaggio e trasferta dal Ticino, voce per voce. Niente sorprese dopo la festa. Raccontatemi data, location e numero di ospiti dal modulo contatti o su WhatsApp: rispondo personalmente, di solito entro poche ore.",
      },
    ],
    relatedLinks: [
      { to: "/dj-ginevra", label: "DJ per eventi a Ginevra" },
      { to: "/dj-berna", label: "DJ per eventi a Berna" },
      { to: "/dj-basilea", label: "DJ per eventi a Basilea" },
      { to: "/dj-matrimoni-ticino", label: "Matrimoni in Ticino" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
    ],
  },
  {
    slug: "/dj-ginevra",
    title: "DJ per Matrimoni ed Eventi a Ginevra – DJ Magix",
    description:
      "DJ per matrimoni ed eventi a Ginevra: servizio completo con audio e luci, trasferta dal Ticino organizzata. Preventivo gratuito.",
    eyebrow: "Ginevra",
    h1: "DJ a Ginevra per Eventi e Matrimoni",
    intro:
      "DJ set di alto profilo sulle rive del Lemano: matrimoni, gala aziendali e feste private a Ginevra con musica su misura.",
    image: "/assets/gallery5.webp",
    paragraphs: [
      {
        h2: "Eventi internazionali sul Lago Lemano",
        text: "Ginevra è la città più internazionale della Svizzera: conduco ogni evento in italiano e preparo con voi scaletta e annunci in anticipo, così anche gli ospiti francofoni e anglofoni seguono ogni momento. Matrimoni multiculturali e cene di gala con la colonna sonora perfetta per ogni ospite.",
      },
      {
        h2: "Servizio completo, zero pensieri",
        text: "Trasferta, montaggio, impianto audio e luci fino a 1000 persone, effetti speciali su richiesta: un unico interlocutore per tutta la parte musicale del tuo evento a Ginevra.",
      },
      {
        h2: "La trasferta Ticino–Ginevra, senza pensieri",
        text: "Ginevra è la mia trasferta più lunga, ma la organizzo io dall'inizio alla fine: viaggio, montaggio in anticipo rispetto all'arrivo degli ospiti, soundcheck e coordinamento con la location sulle rive del Lemano o in campagna. Per i matrimoni concordo con gli sposi ogni momento musicale — dall'aperitivo al primo ballo — settimane prima della data.",
      },
      {
        h2: "Matrimoni, gala e feste private a Ginevra",
        text: "Porto a Ginevra il servizio completo: matrimoni eleganti in riva al lago, cene di gala e eventi aziendali con microfonia wireless per discorsi e premiazioni, feste private con playlist su misura e, su richiesta, karaoke professionale. L'atmosfera giusta per ogni fase della serata, dal sottofondo soft al DJ set finale.",
      },
      {
        h2: "Quanto costa un DJ a Ginevra",
        text: "Il preventivo è gratuito e scritto: include musica, impianto audio e luci, montaggio e trasferta dal Ticino, tutto voce per voce. Matrimoni da CHF 500, feste private da CHF 200-300 più trasferta. Scrivetemi data e location dal modulo o su WhatsApp e riceverete una proposta chiara, senza impegno.",
      },
    ],
    relatedLinks: [
      { to: "/dj-zurigo", label: "DJ per eventi a Zurigo" },
      { to: "/dj-berna", label: "DJ per eventi a Berna" },
      { to: "/dj-matrimoni-ticino", label: "Matrimoni in Ticino" },
      { to: "/blog/scegliere-dj-matrimonio-ticino", label: "Come scegliere il DJ del matrimonio" },
      { to: "/preventivo", label: "Richiedi un preventivo" },
    ],
  },
  {
    slug: "/dj-berna",
    title: "DJ per Matrimoni ed Eventi a Berna – DJ Magix",
    description:
      "DJ per matrimoni ed eventi a Berna: 25 anni di esperienza, impianto audio e luci incluso, trasferta organizzata. Preventivo gratuito.",
    eyebrow: "Berna",
    h1: "DJ a Berna per Eventi e Matrimoni",
    intro:
      "La capitale merita una festa con i fiocchi: DJ Magix porta a Berna 25 anni di esperienza e un sound che fa ballare tutti.",
    image: "/assets/gallery3.webp",
    paragraphs: [
      {
        h2: "Matrimoni ed eventi nella capitale",
        text: "Dalle sale storiche della città vecchia alle location moderne sulle rive dell'Aare: adatto musica e luci a ogni ambiente. Conduco l'evento in italiano e prepariamo insieme in anticipo scaletta e annunci, così la festa scorre liscia anche con ospiti di ogni regione.",
      },
      {
        h2: "Attrezzatura propria, prezzo chiaro",
        text: "Niente noleggi esterni: arrivo a Berna con impianto audio e luci professionale fino a 1000 persone. Preventivo gratuito, senza sorprese.",
      },
      {
        h2: "Dal Ticino a Berna: logistica inclusa",
        text: "La trasferta verso Berna la gestisco interamente io: viaggio, montaggio con largo anticipo, soundcheck prima dell'arrivo degli ospiti e smontaggio a fine serata. Coordinate con la location — sala in città vecchia, cascina nell'Emmental o terrazza sull'Aare — le concordo direttamente con chi gestisce lo spazio, senza farvi da tramite.",
      },
      {
        h2: "Matrimoni, eventi aziendali e feste private",
        text: "A Berna offro il servizio completo: matrimoni con musica per cerimonia, aperitivo, cena e festa; cene aziendali e convention con regia audio e microfoni wireless; compleanni e feste private con playlist costruita sui vostri gusti. Revival anni 80/90, disco dance, afro house e techno: il repertorio giusto per ogni generazione presente.",
      },
      {
        h2: "Preventivo gratuito per il vostro evento a Berna",
        text: "Scrivetemi data, location e numero di ospiti: riceverete una proposta scritta, gratuita e senza impegno, con trasferta inclusa e ogni voce chiara. Matrimoni da CHF 500, feste private da CHF 200-300 più trasferta. Rispondo personalmente a ogni richiesta, di solito in poche ore.",
      },
    ],
    relatedLinks: [
      { to: "/dj-zurigo", label: "DJ per eventi a Zurigo" },
      { to: "/dj-basilea", label: "DJ per eventi a Basilea" },
      { to: "/dj-matrimoni-ticino", label: "Matrimoni in Ticino" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
      { to: "/preventivo", label: "Richiedi un preventivo" },
    ],
  },
  {
    slug: "/dj-basilea",
    title: "DJ per Matrimoni ed Eventi a Basilea – DJ Magix",
    description:
      "DJ per matrimoni ed eventi a Basilea: repertorio internazionale, impianto audio e luci incluso, trasferta organizzata. Preventivo gratuito.",
    eyebrow: "Basilea",
    h1: "DJ a Basilea per Eventi e Matrimoni",
    intro:
      "Tra Svizzera, Francia e Germania: DJ set e repertorio internazionale per i tuoi eventi a Basilea.",
    image: "/assets/gallery4.webp",
    paragraphs: [
      {
        h2: "Il DJ giusto per una città di confine",
        text: "Basilea vive tra tre paesi: conduco l'evento in italiano e prepariamo insieme in anticipo scaletta e annunci, ideale per feste con ospiti da ogni regione. Repertorio che spazia dal revival anni 80/90 alla disco dance, dall'afro house alla techno.",
      },
      {
        h2: "Tutto incluso, anche la trasferta",
        text: "Audio, luci, effetti e montaggio: un solo fornitore per la musica del tuo evento a Basilea. Preventivo gratuito e senza impegno.",
      },
      {
        h2: "Dalla Ticino al Reno: come organizzo la trasferta",
        text: "Per Basilea pianifico tutto con anticipo: viaggio dal Ticino, montaggio dell'impianto ore prima dell'arrivo degli ospiti, soundcheck e coordinamento diretto con la location. Che sia una sala in centro, una location sul Reno o uno spazio industriale riconvertito, adatto audio e luci allo spazio e agli orari concordati.",
      },
      {
        h2: "Matrimoni, aziende e feste private a Basilea",
        text: "Servizio completo anche a Basilea: matrimoni dalla cerimonia al dopocena danzante, eventi aziendali e cene di gala con regia audio per speech e premiazioni, compleanni e feste private con la vostra playlist su misura. Su richiesta fontane fredde ed effetti speciali, dove la location li consente.",
      },
      {
        h2: "Prezzi chiari per Basilea",
        text: "Preventivo gratuito, scritto e senza impegno: musica, impianto, montaggio e trasferta dal Ticino inclusi e dettagliati voce per voce. Matrimoni da CHF 500, feste private da CHF 200-300 più trasferta. Scrivetemi dal modulo contatti o su WhatsApp: rispondo personalmente.",
      },
    ],
    relatedLinks: [
      { to: "/dj-zurigo", label: "DJ per eventi a Zurigo" },
      { to: "/dj-berna", label: "DJ per eventi a Berna" },
      { to: "/dj-eventi-aziendali-svizzera", label: "Eventi aziendali in Svizzera" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
      { to: "/preventivo", label: "Richiedi un preventivo" },
    ],
  },
  {
    slug: "/dj-matrimoni-lago-di-como",
    title: "DJ Matrimoni Lago di Como | Dal Ticino – DJ Magix",
    description:
      "DJ per matrimoni sul Lago di Como: musica su misura, impianto audio e luci incluso, trasferta dal Ticino organizzata. Preventivo gratuito.",
    eyebrow: "Matrimoni — Lago di Como",
    h1: "DJ per Matrimoni sul Lago di Como",
    intro:
      "Il Lago di Como è una delle cornici da matrimonio più belle del mondo: porto musica, luci ed esperienza dal Ticino, a meno di un'ora di strada.",
    image: "/assets/country-dance-lago-lugano.webp",
    paragraphs: [
      {
        h2: "Matrimoni internazionali in riva al lago",
        text: "Il Lago di Como attira coppie da tutto il mondo: ville storiche, terrazze sull'acqua, giardini con vista. Conduco ogni evento in italiano e preparo con voi scaletta e annunci in anticipo — per le coppie internazionali il sito è disponibile anche in inglese e tedesco, così possiamo organizzare tutto a distanza senza fraintendimenti.",
      },
      {
        h2: "Dal Ticino al Lago di Como: vicino e senza pensieri",
        text: "Da Lugano-Paradiso a Como, Cernobbio, Tremezzo o Bellagio il viaggio è breve: arrivo con largo anticipo, monto l'impianto e faccio il soundcheck prima che arrivino gli ospiti. Audio e luci professionali fino a 1000 persone sono sempre inclusi — la location non deve noleggiare nulla.",
      },
      {
        h2: "La colonna sonora giusta per ogni momento",
        text: "Cerimonia e aperitivo con atmosfere eleganti, cena con sottofondo curato, e poi la festa: revival anni 80/90, disco dance, afro house e techno, con la scaletta costruita insieme a voi settimane prima. Su richiesta fontane fredde per il primo ballo o il taglio della torta, dove la location lo consente.",
      },
      {
        h2: "Prezzi chiari, preventivo scritto",
        text: "I matrimoni partono da CHF 500 più la trasferta, sempre indicata in modo trasparente nel preventivo: musica, impianto, montaggio e viaggio, voce per voce, senza sorprese. Il preventivo è gratuito e senza impegno — e per le location del primo bacino il sopralluogo è gratuito.",
      },
      {
        h2: "Come prenotare la vostra data",
        text: "I weekend tra maggio e settembre sono i più richiesti, sul Lago di Como ancora di più: appena avete la data, scrivetemi dal modulo contatti o su WhatsApp con location e numero di ospiti. Rispondo personalmente, di solito entro poche ore, e blocchiamo insieme la data.",
      },
    ],
    relatedLinks: [
      { to: "/dj-matrimoni-lugano", label: "Matrimoni a Lugano" },
      { to: "/dj-matrimoni-ticino", label: "Matrimoni in Ticino" },
      { to: "/blog/canzoni-primo-ballo-matrimonio", label: "Le canzoni per il primo ballo" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ" },
      { to: "/preventivo", label: "Preventivo gratuito" },
    ],
  },
  {
    slug: "/chi-sono",
    title: "DJ Magix | 25 Anni di Esperienza, DJ e Producer a Lugano",
    description:
      "Chi è DJ Magix: DJ e producer di Lugano-Paradiso, 25 anni di carriera e oltre 1500 eventi tra Svizzera e Nord Italia.",
    eyebrow: "Chi Sono",
    h1: "DJ Magix — 25 Anni di Musica, Emozione e Tecnologia",
    intro:
      "Un quarto di secolo dietro la console, dalla Ticino a tutta la Svizzera: questa è la mia storia.",
    image: "/assets/banner.webp",
    section: "about",
    paragraphs: [
      {
        h2: "Dalla passione alla professione",
        text: "Ho iniziato a mixare negli anni '90 e non ho più smesso: oltre 1500 eventi tra matrimoni, feste di paese, club ed eventi aziendali. La mia forza è leggere la pista e creare l'alchimia perfetta tra generazioni e generi diversi.",
      },
      {
        h2: "Producer e studio di registrazione a Bedano",
        text: "Non solo DJ set: nel mio studio di registrazione a Bedano realizzo remix, mashup e custom edits esclusivi, oltre a offrire formazione per chi vuole imparare l'arte del DJ. Ogni evento può avere una colonna sonora che non troverai da nessun'altra parte.",
      },
    ],
    relatedLinks: [
      { to: "/servizi", label: "Tutti i servizi DJ" },
      { to: "/dj-matrimoni-lugano", label: "Matrimoni a Lugano" },
      { to: "/blog", label: "Le guide del blog" },
      { to: "/contatti", label: "Contattami" },
    ],
  },
  {
    slug: "/servizi",
    title: "Servizi DJ per Eventi in Svizzera | DJ Magix",
    description:
      "DJ set, audio, luci, karaoke, fontane fredde e animazione per matrimoni, feste e aziende. Scopri tutti i servizi di DJ Magix.",
    eyebrow: "Servizi",
    h1: "Servizi DJ di Alto Profilo in Svizzera",
    intro:
      "Ogni evento è una produzione su misura: musica, luci ed emozioni curate nei minimi dettagli.",
    image: "/assets/gallery1.webp",
    section: "services",
    paragraphs: [
      {
        h2: "Per privati, comuni e aziende",
        text: "Matrimoni, compleanni, feste di paese, sagre, club, lounge bar ed eventi aziendali: qualunque sia la tua occasione, costruisco il DJ set perfetto con sound anni 80/90, disco dance, afro house e techno.",
      },
      {
        h2: "Attrezzatura ed effetti inclusi",
        text: "Impianto audio e luci professionale fino a 1000 persone, microfoni wireless, karaoke e su richiesta fontane fredde ed effetti speciali. Feste private da CHF 200-300, matrimoni da CHF 500: chiedi un preventivo gratuito.",
      },
    ],
    relatedLinks: [
      { to: "/dj-matrimoni-ticino", label: "Matrimoni in Ticino" },
      { to: "/dj-compleanni-feste-private", label: "Compleanni e feste private" },
      { to: "/dj-festival-party-stagionali", label: "Feste di paese e festival" },
      { to: "/dj-eventi-aziendali-svizzera", label: "Eventi aziendali" },
      { to: "/preventivo", label: "Preventivo gratuito" },
    ],
  },
  {
    slug: "/gallery",
    title: "Gallery — Foto Eventi e Matrimoni | DJ Magix",
    description:
      "Foto e atmosfere degli eventi di DJ Magix in Ticino e Svizzera: matrimoni, festival, club e feste private. Guarda la gallery.",
    eyebrow: "Gallery",
    h1: "Atmosfere & Momenti d'Oro",
    intro:
      "Scorci delle serate che hanno fatto ballare la Svizzera: matrimoni, festival, club e feste private.",
    image: "/assets/gallery2.webp",
    section: "gallery",
    paragraphs: [
      {
        h2: "Ogni foto, una festa vera",
        text: "Queste immagini raccontano eventi reali: piste piene, sposi emozionati, piazze in festa. La stessa energia che posso portare al tuo evento.",
      },
    ],
    relatedLinks: [
      { to: "/servizi", label: "I servizi per il tuo evento" },
      { to: "/dj-matrimoni-lugano", label: "Matrimoni a Lugano" },
      { to: "/preventivo", label: "Preventivo gratuito" },
    ],
  },
  {
    slug: "/contatti",
    title: "Contatti DJ Magix | WhatsApp, Telefono, Email",
    description:
      "Scrivi o chiama DJ Magix a Lugano-Paradiso: 076 441 13 59, WhatsApp o modulo. Preventivo gratuito e senza impegno.",
    eyebrow: "Contatti",
    h1: "Parliamo del Tuo Evento",
    intro:
      "Telefono, WhatsApp, email o Instagram: scegli il canale che preferisci, rispondo personalmente a ogni richiesta.",
    image: "/assets/gallery3.webp",
    section: "contact",
    paragraphs: [
      {
        h2: "Dove opero",
        text: "Base a Lugano-Paradiso e disponibilità in tutto il Ticino, con trasferte fino a 200 km: Zurigo, Ginevra, Berna, Basilea e Nord Italia (Como, Milano).",
      },
    ],
    relatedLinks: [
      { to: "/preventivo", label: "Modulo preventivo" },
      { to: "/servizi", label: "I servizi DJ" },
      { to: "/chi-sono", label: "Chi è DJ Magix" },
    ],
  },
  {
    slug: "/preventivo",
    title: "Preventivo DJ Gratuito per il Tuo Evento | DJ Magix",
    description:
      "Racconta il tuo evento nel modulo: riceverai un preventivo gratuito e senza impegno da DJ Magix.",
    eyebrow: "Preventivo",
    h1: "Richiedi il Tuo Preventivo Gratuito",
    intro:
      "Raccontami data, luogo e tipo di evento: riceverai una proposta su misura, gratuita e senza impegno. Feste private da CHF 200-300, matrimoni da CHF 500.",
    image: "/assets/gallery4.webp",
    section: "contact",
    paragraphs: [
      {
        h2: "Come funziona",
        text: "Compila il modulo o scrivimi su WhatsApp con data, location e numero di ospiti. Ti rispondo personalmente con una proposta dettagliata: musica, attrezzatura, tempi e prezzo chiaro.",
      },
    ],
    relatedLinks: [
      { to: "/contatti", label: "Tutti i contatti" },
      { to: "/servizi", label: "Cosa include il servizio" },
      { to: "/blog/costo-dj-svizzera", label: "Quanto costa un DJ in Svizzera" },
    ],
  },
];
